const API_WEB_APP_LINK = process.env.VUE_APP_API_WEB_APP_LINK;
const API_USER_LINK = process.env.VUE_APP_API_USER_LINK;
const MERCURE_LINK = process.env.VUE_APP_MERCURE_LINK;

export default Object.freeze({
  /** Mercure */
  MERCURE_LINK() {
    return MERCURE_LINK;
  },
  /** File system  */
  PUBLIC_PATH() {
    return API_WEB_APP_LINK;
  },

  /** AUTH */
  LOGIN() {
    return API_USER_LINK + "/token/login";
  },
  TOKEN_REFRESH() {
    return API_USER_LINK + "/token/refresh";
  },

  /** FORGOT PASSWORD */
  CHECK_EMAIL() {
    return API_USER_LINK + "/users/check-email";
  },
  CHECK_USERNAME() {
    return API_USER_LINK + "/users/check-username-bo";
  },
  CHECK_VERIFICATION_CODE() {
    return API_USER_LINK + "/users/verification-code/check";
  },
  SET_PASSWORD() {
    return API_USER_LINK + "/users/verification-code/set-password";
  },

  /** GENERAL */ 
  GENERAL() {
    return API_WEB_APP_LINK + "/generals";
  },

  /** BUILDINGS */
  BUILDING_FETCH() {
    return API_WEB_APP_LINK + "/buildings?pagination=false";
  },
  BUILDING_GET(id) {
    return API_WEB_APP_LINK + "/buildings/" + id;
  },

  /** BUILDING LOTS */
  BUILDING_LOT_FETCH(buildingId) {
    // NOTE: get only the ones that belong to current building
    return API_WEB_APP_LINK + `/buildings/${buildingId}/building_lots?pagination=false`;
  },

  /** BUILDING OWNERS */
  BUILDING_OWNER_FETCH(buildingId) {
    return (
      API_WEB_APP_LINK +
      `/buildings/${buildingId}/building_owners?pagination=false&order[lastname]=asc`
    );
  },
  BUILDING_OWNER_PUT(id) {
    return API_WEB_APP_LINK + "/building_owners/" + id;
  },
  BUILDING_OWNER_GET_BY_USER_ID(userId) {
    return API_WEB_APP_LINK + "/building_owners?userId=" + userId;
  },
  BUILDING_OWNER_POST() {
    return API_WEB_APP_LINK + "/building_owners";
  },

  /** CONTACT */
  CONTACT_GET(id) {
    return API_WEB_APP_LINK + "/contacts/" + id;
  },
  CONTACT_GET_BY_USER_ID(userId) {
    return API_WEB_APP_LINK + "/contacts?userId=" + userId;
  },

  /** MAJORITIES */
  MAJORITY_FETCH() {
    return API_WEB_APP_LINK + "/majorities?pagination=false";
  },

  /** MANDATES */
  MANDATE_FETCH(meetingId, properties) {
    return API_WEB_APP_LINK + `/meetings/${meetingId}/mandates?pagination=false&${properties}`;
  },
  MANDATE_UPDATE_MULTIPLE_LAST_SEEN() {
    return API_WEB_APP_LINK + "/mandates/update-multiple-last-seen";
  },
  MANDATE_CORRESPONDENCE_VOTING() {
    return API_WEB_APP_LINK + "/mandate/correspondence-voting";
  },
  MANDATE_PDF_CREATE_MERGE() {
    return API_WEB_APP_LINK + "/mandate/pdf/create/merge";
  },
  MANDATE_PDF_UPDATE_CORRESPONDENCE() {
    return API_WEB_APP_LINK + "/mandate/pdf/update/correspondence";
  },
  MANDATE_SIGN_CORRESPONDENCE(mandateId) {
    return API_WEB_APP_LINK + `/mandates/${mandateId}/sign_correspondence`;
  },
  

  /** MEETING-RESOLUTION */
  MEETING_RESOLUTION_FETCH(meetingId) {
    return API_WEB_APP_LINK + `/meetings/${meetingId}/meeting_resolutions?pagination=false`;
  },

  /** MEETINGS */
  MEETING_GET(id) {
    return API_WEB_APP_LINK + "/meetings/" + id;
  },
  MEETING_GET_BY_BUILDING_WITH_BO_DOCUMENTS(buildingId) {
    return API_WEB_APP_LINK + `/meetings/get_by_building_with_bo_documents?building=${buildingId}`;
  },
  MEETING_DETAILS_FOR_CORRESPONDENCE_VOTING($meetingId) {
    return API_WEB_APP_LINK + `/meetings/details_for_correspondence_voting/${$meetingId}`;
  },

  /** RESOLUTION-VOTE */
  RESOLUTION_VOTE_FETCH(meetingResolutionId) {
    return (
      API_WEB_APP_LINK +
      `/meeting_resolutions/${meetingResolutionId}/resolution_votes?pagination=false`
    );
  },
  RESOLUTION_VOTE_POST() {
    return API_WEB_APP_LINK + "/resolution_votes";
  },
  RESOLUTION_VOTE_PUT(id) {
    return API_WEB_APP_LINK + "/resolution_votes/" + id;
  },

  /** VOTING CATEGORIES */
  VOTING_CATEGORY_FETCH(buildingId) {
    // get only the ones that belong to current building
    return API_WEB_APP_LINK + `/buildings/${buildingId}/voting_categories?pagination=false`;
  },

  /** MEETING_GUESTS */
  MEETING_GUESTS_FETCH() {
    return API_WEB_APP_LINK + "/meeting_guests?pagination=false";
  },
  MEETING_GUEST_GET_BY_USER_ID(userId) {
    return API_WEB_APP_LINK + "/meeting_guests?userId=" + userId;
  },

  /** USER */
  USER_GET(id) {
    return API_USER_LINK + "/users/" + id;
  },
  USER_PUT(id) {
    return API_USER_LINK + "/users/" + id;
  },
  USER_GET_ADMIN_BY_AGENCY(agencyId) {
    return API_USER_LINK + `/users/agency-admin?agency_id=${agencyId}`;
  },

  LIVEKIT_GET_TOKEN() {
    return API_WEB_APP_LINK + "/livekit/get-participant-token";
  },

  /** BUILDING_MAJORITIES */
  BUILDING_MAJORITIES_BY_BUILDING(buildingId) {
    return API_WEB_APP_LINK + `/building_majorities/by_building/${buildingId}`;
  },

  /** MEETING_CORRESPONDENCE */
  MEETING_CORRESPONDENCE_VOTE_GET(id) {
    return API_WEB_APP_LINK + "/meeting_correspondence_votes/" + id;
  },
  
  MEETING_CORRESPONDENCE_VOTE_POST() {
    return API_WEB_APP_LINK + "/meeting_correspondence_votes";
  },

  MEETING_CORRESPONDENCE_VOTE_PUT(id) {
    return API_WEB_APP_LINK + "/meeting_correspondence_votes/" + id;
  },

  /** CONFIGURATION */
  CONFIGURATION_GET_BY_AGENCY(agencyId) {
    return API_WEB_APP_LINK + `/configurations?agency_id=${agencyId}`;
  },

  MEDIA_GET_IN_BASE64(id) {
    return API_WEB_APP_LINK + "/media/" + id + "/get-in-base64";
  },
});
